/**
 * Inline Editing analytics actions
 *
 * Events specified in the design doc (section 14.2) for product analytics,
 * plus operational events for monitoring save lifecycle and undo/redo usage.
 *
 * @see docs/plans/2026-02-24-project-detail-inline-editing-design.md#142-new-analytics-constants
 */
export const EDITING_ACTIONS = {
  // ---------------------------------------------------------------------------
  // Panel lifecycle (design doc section 14.2)
  // ---------------------------------------------------------------------------
  EDIT_PANEL_OPENED: 'edit_panel_opened',
  EDIT_PANEL_CLOSED: 'edit_panel_closed',

  // ---------------------------------------------------------------------------
  // Session outcomes (design doc section 14.2)
  // ---------------------------------------------------------------------------
  EDIT_SESSION_SAVED: 'edit_session_saved',
  EDIT_SESSION_DISCARDED: 'edit_session_discarded',

  // ---------------------------------------------------------------------------
  // Navigation (design doc section 14.2)
  // ---------------------------------------------------------------------------
  EDIT_SECTION_SELECTED: 'edit_section_selected',

  // ---------------------------------------------------------------------------
  // Concurrency (design doc section 14.2)
  // ---------------------------------------------------------------------------
  EDIT_LOCK_BLOCKED: 'edit_lock_blocked',
  EDIT_VERSION_CONFLICT: 'edit_version_conflict',

  // ---------------------------------------------------------------------------
  // History (design doc section 14.2)
  // ---------------------------------------------------------------------------
  EDIT_RESTORE_COMPLETED: 'edit_restore_completed',
  CHANGELOG_VIEWED: 'changelog_viewed',
  CHANGELOG_EXPORT_REQUESTED: 'changelog_export_requested',

  // ---------------------------------------------------------------------------
  // Operational monitoring (supplementary — not in design doc section 14.2
  // but valuable for save lifecycle observability and debugging)
  // ---------------------------------------------------------------------------
  EDIT_SAVE_STARTED: 'edit_save_started',
  EDIT_SAVE_FAILED: 'edit_save_failed',
  EDIT_UNDO: 'edit_undo',
  EDIT_REDO: 'edit_redo',
  EDIT_RESTORE_STARTED: 'edit_restore_started',
} as const;
